export const dateFormatter = {
  datepickerDateFormat () {
    return 'dd.mm.yy';
  },

  timepickerTimeFormat () {
    return 'HH:mm:ss';
  },

  // moment formatters
  momentDateFormat () {
    return 'DD.MM.YYYY';
  },

  momentDateFormatShort () {
    return 'DD.MM.YY';
  },

  momentDatetimeFormat () {
    return 'DD.MM.YYYY HH:mm:ss';
  },

  momentDateMonthFormat () {
    return 'DD.MM';
  },

  momentTimeFormat (options) {
    var parts = [];
    options.noHours !== true ? parts.push('HH') : {};
    options.noMinutes !== true ? parts.push('mm') : {};
    options.noSeconds !== true ? parts.push('ss') : {};
    return parts.join(':');
  },

  momentDateGroupedMonthsFormat () {
    return 'YYYY, MMMM';
  },

  momentDateGroupedQuartersFormat () {
    return 'YYYY, кв. D';
  },

  momentDateGroupedYearsFormat () {
    return 'YYYY';
  },

  momentMonthApiFormat () {
    return 'YYYY-MM';
  },

  momentDateApiFormat () {
    return 'YYYY-MM-DD';
  },

  momentTimeApiFormat () {
    return 'HH:mm:ss';
  },

  momentDateTimeApiFormat () {
    return 'YYYY-MM-DDTHH:mm:ss';
  }
};
